import { toast } from "sonner";
import { CalendarClock } from "lucide-react";
import { api, errMsg, fmtDate, kina } from "@/lib/api";

export const UpcomingRides = ({ rides, onChange }) => {
  if (!rides.length) return null;
  const cancel = async (id) => {
    try {
      await api.post(`/bookings/${id}/cancel`);
      toast.success("Scheduled ride cancelled");
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid="upcoming-rides" className="mb-6 rounded-2xl border border-blue-100 bg-white p-5">
      <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-blue-700"><CalendarClock className="h-4 w-4" /> Upcoming scheduled rides</p>
      <div className="divide-y divide-slate-100">
        {rides.map((r) => (
          <div key={r.id} data-testid={`upcoming-ride-${r.id}`} className="flex flex-col gap-2 py-3 sm:flex-row sm:items-center">
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900">{fmtDate(r.scheduled_for)}</p>
              <p className="truncate text-sm text-slate-500">{r.pickup.address} → {r.dropoff.address}</p>
            </div>
            <span className="font-mono-num font-semibold text-slate-900">{kina(r.fare)}</span>
            <button data-testid={`cancel-scheduled-${r.id}`} onClick={() => cancel(r.id)} className="text-xs font-semibold text-red-600 hover:underline">Cancel</button>
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs text-slate-400">Drivers can accept your ride from 30 minutes before pickup time.</p>
    </div>
  );
};

const pad = (n) => String(n).padStart(2, "0");
export const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export const WhenPicker = ({ later, setLater, at, setAt }) => {
  const min = toLocalInput(new Date(Date.now() + 35 * 60000));
  const max = toLocalInput(new Date(Date.now() + 14 * 86400000));
  return (
    <div className="rounded-2xl border-2 border-slate-100 bg-white p-4">
      <span className="text-xs font-bold uppercase tracking-widest text-slate-500">When</span>
      <div className="mt-2 grid grid-cols-2 gap-2">
        {[[false, "Ride now"], [true, "Schedule for later"]].map(([v, l]) => (
          <button key={l} type="button" data-testid={`when-${v ? "later" : "now"}-button`} onClick={() => setLater(v)} className={`h-10 rounded-xl text-sm font-semibold transition-colors ${later === v ? "bg-blue-700 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{l}</button>
        ))}
      </div>
      {later && (
        <input data-testid="schedule-datetime-input" type="datetime-local" min={min} max={max} value={at} onChange={(e) => setAt(e.target.value)} className="mt-3 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-blue-600" />
      )}
    </div>
  );
};
